// Package Imports
import { toJS } from "mobx";

// Package Imports
import NeedTypeEnum from "../../../../constants/NeedTypeEnum";
import OptimizationStore from "../../store/OptimizationStore";
import AuthStore from "../../../login/store/AuthStore";
import StorageKeys from "constants/StorageKeys";

const generateAddNeedDataStructure = (requestObj, needType) => {
  const journeyData = toJS(AuthStore.journeyData);
  let { family_details_list, journey_details } = journeyData;
  localStorage.setItem(
    StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM,
    false
  );

  let productList = toJS(OptimizationStore.product_list_data);
  let needList = AuthStore.needMasterList;
  let selectedNeed = needList.find(
    (item) => item.id === requestObj.need_id
  );

  let laDetails = family_details_list.find(
    (familyData) => familyData.id === requestObj.family_member_id
  );

  let secondaryLaDetails = family_details_list.find(
    (familyData) => familyData.id === requestObj.secondary_la
  );

  let riskList = [];
  let productWiseRiskList = [];
  if (journey_details.high_risk_selected) riskList.push("high");
  riskList = [...riskList, ...["medium", "low"]];
  riskList.forEach((item) => {
    productWiseRiskList.push({
      risk: item,
      BI: {},
      bi_request: {},
      update_BI: false,
    });
  });

  let needDetails = {
    need_unique_name: selectedNeed.unique_name,
    need_title: selectedNeed.name,
    is_removed: false,
    data: [
      {
        BI:
          selectedNeed.unique_name === "protection_for_my_family"
            ? { risk: "high", BI: {}, bi_request: {}, update_BI: false }
            : productWiseRiskList,
        dob: laDetails.dob,
        family_member_type: laDetails.family_member_type,
        gender: laDetails.gender,
        id: laDetails.id,
        income_type: laDetails.income_type,
        isSelected: true,
        monthly_income: laDetails.monthly_income,
        payout_mode: requestObj.payout_mode,
        life_assured_details: laDetails,
        secondary_la_Details: secondaryLaDetails,
        proposer_details: {},
      },
    ],
  };

  productList.forEach((item) => {
    if (item.need_unique_name === selectedNeed.unique_name) {
      item.data.map((productData) => {
        productData.isDisabledNeed = true;
      });
    } else {
      const isNeedExist = productList.some(
        (singleNeed) =>
          singleNeed.need_unique_name === selectedNeed.unique_name
      );
      if (!isNeedExist) {
        productList.splice(0, 0, needDetails);
      }
    }
  });

  let growMyMoneyProduct = [];
  let saveForMyChildrenProduct = [];
  let saveForRetirementProduct = [];
  let protectionForFamilyProduct = [];
  let protectionForHealthProduct = [];

  for (let needObj of toJS(productList)) {
    let needName = needObj.need_unique_name;

    switch (needName) {
      case NeedTypeEnum.GROW_MY_MONEY:
        growMyMoneyProduct.push(needObj);
        break;

      case NeedTypeEnum.SAVE_FOR_CHILDREN:
        saveForMyChildrenProduct.push(needObj);
        break;

      case NeedTypeEnum.SAVE_FOR_RETIREMENT:
        saveForRetirementProduct.push(needObj);
        break;

      case NeedTypeEnum.PROTECTION_FOR_MY_FAMILY:
        protectionForFamilyProduct.push(needObj);
        break;

      case NeedTypeEnum.PROTECTION_FOR_MY_HEALTH:
        protectionForHealthProduct.push(needObj);
        break;

      default:
        break;
    }
  }

  let updatedProductListBasedOnNeed = [
    ...growMyMoneyProduct,
    ...saveForMyChildrenProduct,
    ...saveForRetirementProduct,
    ...protectionForFamilyProduct,
    ...protectionForHealthProduct,
  ];

  productList = updatedProductListBasedOnNeed;

  OptimizationStore.product_list_data = [...productList];
  journeyData.journey_need.forEach((item) => {
    if (item.need === requestObj.need_id) {
      item.is_selected = true;
      item.is_removed = false;
    }
  });
  AuthStore.setJourneyData(journeyData);
  OptimizationStore.isCalculatorUsed = false;
};

export default generateAddNeedDataStructure;
